import { NOTE_SOURCE_LABEL_MAP } from "@/components/note/editor/source-bar/note-editor-source-bar-chip.constants";
import { AudioSourceAvailabilityState } from "./audio-source-availability";

export const resolveAudioSourceLabel = ({
  availabilityState,
}: {
  availabilityState?: AudioSourceAvailabilityState;
}): string => {
  if (availabilityState === AudioSourceAvailabilityState.Recording) {
    return "Audio recording in progress";
  }

  if (availabilityState === AudioSourceAvailabilityState.Uploading) {
    return "Uploading audio recording";
  }

  if (availabilityState === AudioSourceAvailabilityState.Error) {
    return "Audio recording unavailable";
  }

  if (availabilityState === AudioSourceAvailabilityState.Skipped) {
    return "Audio upload skipped";
  }

  return NOTE_SOURCE_LABEL_MAP.AUDIO;
};

export const resolveAudioSourceSubtitle = ({
  availabilityState,
}: {
  availabilityState?: AudioSourceAvailabilityState;
}): string => {
  if (availabilityState === AudioSourceAvailabilityState.Recording) {
    return "Recording...";
  }

  if (availabilityState === AudioSourceAvailabilityState.Uploading) {
    return "Uploading...";
  }

  if (availabilityState === AudioSourceAvailabilityState.Error) {
    return "Upload failed";
  }

  if (availabilityState === AudioSourceAvailabilityState.Skipped) {
    return "Upload skipped";
  }

  return "";
};

export const resolveAudioUnavailableStatusMessage = ({
  availabilityState,
}: {
  availabilityState?: AudioSourceAvailabilityState;
}): string => {
  if (availabilityState === AudioSourceAvailabilityState.Recording) {
    return "Recording...";
  }

  if (availabilityState === AudioSourceAvailabilityState.Uploading) {
    return "Uploading...";
  }

  if (availabilityState === AudioSourceAvailabilityState.Skipped) {
    return "Upload skipped";
  }

  return "Voice recording unavailable";
};
